import httpClient from "./httpClient";

const END_POINT = "";

const getPath = (path, ref) =>
  httpClient.post(END_POINT + "/lnks/play/sp-json/" + path, { ref });

const getAuth = path =>
  httpClient.get(END_POINT + "/ppvapi/status_auth/" + path);

const setPos = (pos_update, pos) =>
  httpClient.get(END_POINT + "/ppvapi/setpos/" + pos_update + "/" + pos);

export { getPath, getAuth, setPos };
